module.exports = __webpack_public_path__ + "img/bank-active.6df81d6b.svg";